import dashboard from '@/router/routes/dashboard'
import login from '@/router/routes/login'
import externalForm from '@/router/routes/externalForm'
import errorPages from '@/router/routes/errorsPages'
import document from '@/router/routes/document'
import successCard from '@/router/routes/successCard'
import publish from '@/router/routes/publish'
import donorContact from '@/router/routes/donorContact'
import nextEditionDocument from '@/router/routes/nextEditionDocument'

export default [
  dashboard,
  login,
  externalForm,
  document,
  publish,
  ...nextEditionDocument,
  ...successCard,
  ...donorContact,
  ...errorPages
]
